import { render, staticRenderFns } from "./TrainSearch.vue?vue&type=template&id=2cf3884d&scoped=true&"
import script from "./TrainSearch.vue?vue&type=script&lang=js&"
export * from "./TrainSearch.vue?vue&type=script&lang=js&"
import style0 from "./TrainSearch.vue?vue&type=style&index=0&id=2cf3884d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf3884d",
  null
  
)

export default component.exports